import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BASE_API_URL } from '@cnt-workspace/data-access';
import { ICaretakerResponse, ICaretakerWhere } from '@curbnturf/entities';
import { objectToUrlParams } from '@curbnturf/helpers';
import { Observable } from 'rxjs';

const API_URL = BASE_API_URL + 'caretaker';

/** Caretaker change requests/submissions for boondocks and POIs. Moved from the app's services/caretaker.service.ts. */
@Injectable({ providedIn: 'root' })
export class AdminCaretakerApiService {
  private readonly http = inject(HttpClient);

  list(query: ICaretakerWhere = {}): Observable<ICaretakerResponse> {
    return this.http.get<ICaretakerResponse>(`${API_URL}?${objectToUrlParams(query, true)}`);
  }
}
